import * as React from "react";
const SvgArrowSmall = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 20,
    height: 20,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement("path", { d: "M6 3L2.5359 7.5L9.4641 7.5L6 3Z", fill: "currentColor" })
);
export default SvgArrowSmall;
